// We're using custom policy pages
// Shopify Policy pages cannot be redirected from https://admin.shopify.com/store/astr-the-label/redirects or using inline JS/CSS from https://admin.shopify.com/store/astr-the-label/settings/legal
export default () => {
  if (window.location.pathname.includes('/policies/refund-policy')) {
    window.location.replace('/pages/returns');
    return;
  }

  if (window.location.pathname.includes('/policies/shipping-policy')) {
    window.location.replace('/pages/shipping');
    return;
  }

  if (window.location.pathname.includes('/pages/privacy-policy')) {
    window.location.replace('/policies/privacy-policy');
    return;
  }

  if (window.location.pathname.includes('/pages/terms-conditions')) {
    window.location.replace('/policies/terms-of-service');
    return;
  }
};
